import React from 'react'
import { useEffect } from 'react'

export default function ProgressBar() {
    useEffect(() => {
        function updateScrollProgress() {
          const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
          const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
          const scrolled = (winScroll / height) * 100;
          document.getElementById("myBar").style.width = scrolled + "%";
        }
        window.addEventListener("scroll", updateScrollProgress);

        return () => {
            window.removeEventListener("scroll", updateScrollProgress);
          };
        }, []);
        
  return (
    <div className="progress-container">
    <div className="progress-bar" id="myBar"></div>
    </div>
  )
}
